import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, LogOut, ClipboardList, CalendarCog, Megaphone, KeyRound, Images, Link2 } from 'lucide-react'
import { useAuth } from '../auth/AuthContext'
import { AdminDemandes } from '../components/admin/AdminDemandes'
import { AdminAnnonces } from '../components/admin/AdminAnnonces'
import { AdminCarousels } from '../components/admin/AdminCarousels'
import { AdminLiens } from '../components/admin/AdminLiens'
import { AdminEnlevementConfig } from '../components/admin/AdminEnlevementConfig'
import { AdminCompte } from '../components/admin/AdminCompte'

type Onglet = 'demandes' | 'annonces' | 'carrousels' | 'liens' | 'campagne' | 'compte'

export function Admin() {
  const { user, logout } = useAuth()
  const [onglet, setOnglet] = useState<Onglet>('demandes')

  return (
    <div className="min-h-screen bg-sand">
      <header className="border-b border-navy/10 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4 lg:px-8">
          <div className="flex items-center gap-3">
            <img src="/img/logo-maison-gilles.png" alt="" className="h-10 w-10" />
            <div>
              <h1 className="font-display text-lg font-bold text-navy-dk">Tableau de bord</h1>
              <p className="text-xs text-ink/55">Connecté en tant que {user?.display_name}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" className="inline-flex items-center gap-1.5 rounded-full border border-navy/20 px-4 py-2 text-sm font-medium text-navy hover:bg-navy/5">
              <ArrowLeft className="h-4 w-4" /> Voir le site
            </Link>
            <button onClick={logout} className="inline-flex items-center gap-1.5 rounded-full bg-navy px-4 py-2 text-sm font-medium text-white hover:bg-navy-dk">
              <LogOut className="h-4 w-4" /> Déconnexion
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-5 py-8 lg:px-8">
        {/* Onglets */}
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => setOnglet('demandes')}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              onglet === 'demandes' ? 'bg-navy text-white' : 'bg-white text-ink/70 ring-1 ring-navy/15 hover:bg-white/60'
            }`}
          >
            <ClipboardList className="h-4 w-4" /> Demandes d'enlèvement
          </button>
          <button
            onClick={() => setOnglet('annonces')}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              onglet === 'annonces' ? 'bg-navy text-white' : 'bg-white text-ink/70 ring-1 ring-navy/15 hover:bg-white/60'
            }`}
          >
            <Megaphone className="h-4 w-4" /> Annonces
          </button>
          <button
            onClick={() => setOnglet('carrousels')}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              onglet === 'carrousels' ? 'bg-navy text-white' : 'bg-white text-ink/70 ring-1 ring-navy/15 hover:bg-white/60'
            }`}
          >
            <Images className="h-4 w-4" /> Carrousels
          </button>
          <button
            onClick={() => setOnglet('liens')}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              onglet === 'liens' ? 'bg-navy text-white' : 'bg-white text-ink/70 ring-1 ring-navy/15 hover:bg-white/60'
            }`}
          >
            <Link2 className="h-4 w-4" /> Liens
          </button>
          <button
            onClick={() => setOnglet('campagne')}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              onglet === 'campagne' ? 'bg-navy text-white' : 'bg-white text-ink/70 ring-1 ring-navy/15 hover:bg-white/60'
            }`}
          >
            <CalendarCog className="h-4 w-4" /> Campagne
          </button>
          <button
            onClick={() => setOnglet('compte')}
            className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${
              onglet === 'compte' ? 'bg-navy text-white' : 'bg-white text-ink/70 ring-1 ring-navy/15 hover:bg-white/60'
            }`}
          >
            <KeyRound className="h-4 w-4" /> Mon compte
          </button>
        </div>

        <div className="mt-6 rounded-2xl border border-navy/10 bg-white p-5 shadow-card sm:p-6">
          {onglet === 'demandes' && <AdminDemandes />}
          {onglet === 'annonces' && <AdminAnnonces />}
          {onglet === 'carrousels' && <AdminCarousels />}
          {onglet === 'liens' && <AdminLiens />}
          {onglet === 'campagne' && <AdminEnlevementConfig />}
          {onglet === 'compte' && <AdminCompte />}
        </div>
      </main>
    </div>
  )
}
